import { FC } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ISortableItemProps } from './types';
import styles from './imageOrganiserPopUp.module.scss';

export const SotableItem: FC<ISortableItemProps> = ({ id, imageUrl, isDragging, isActive, name }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      id={id}
      className={`${styles.imageWrapper} ${isDragging ? styles.dragging : ''} ${isActive ? styles.active : ''} `}
      style={style}>
      <img src={imageUrl} alt={`popup-image-${id}`} className={styles.image} />
      {name && <p className={styles.imageName}>{name}</p>}
    </div>
  );
};
